import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-event-log',
    imports: [CommonModule],
    template: `
    <p>
      event-log works!
    </p>
  `,
    styles: []
})
export class EventLogComponent {

}
